import { useEffect, useRef, useState } from 'react'
import { useScroll, useTransform } from 'framer-motion'

import { TextContainer } from 'components/container'
import Image1 from './assets/Tatar_writing-1.webp'
import Image2 from './assets/Tatar_writing-2.webp'
import Image3 from './assets/Tatar_writing-3.webp'
import Image4 from './assets/Tatar_writing-4.webp'
import { SmallGraphics } from '../../../styled'
import { ImageWrapper, Placeholder, SlideImage, ThreadGraphics } from './styled'

const IMAGES = [Image1, Image2, Image3, Image4]

export const Slideshow = () => {
  const ref = useRef(null)
  const [visibleImageIndex, setVisibleImageIndex] = useState(0)
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['end end', 'start start'],
  })
  const slideNum = useTransform(scrollYProgress, input =>
    Math.round(input * (IMAGES.length - 1))
  )

  useEffect(() => {
    slideNum.on('change', () => setVisibleImageIndex(slideNum.get()))
  }, [])

  return (
    <>
      <ThreadGraphics />
      <TextContainer>
        <SmallGraphics ref={ref}>
          <ImageWrapper>
            <Placeholder src={Image1} alt="" />

            {IMAGES.map(image => (
              <SlideImage
                isActive={IMAGES[visibleImageIndex] === image}
                src={image}
              />
            ))}
          </ImageWrapper>
        </SmallGraphics>
      </TextContainer>
    </>
  )
}
